// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const EntraIdIcon = createSvgIcon(
  <svg
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    clipRule="evenodd"
    viewBox="0 0 200 200"
  >
    <path fill="none" d="M-.01-.02H200V200H0z" />
    <path
      fill="#225086"
      fillRule="nonzero"
      d="M44.27 153.95c4.16 2.6 11.07 5.48 18.38 5.48 6.66 0 12.85-1.93 17.97-5.22h.03L100 142.1v43.67c-3.07 0-6.15-.84-8.84-2.51z"
    />
    <path
      fill="#6DF"
      fillRule="nonzero"
      d="m87.7 19.66-80.42 90.7c-6.2 7.02-4.58 17.61 3.47 22.64l33.52 20.95c4.16 2.6 11.07 5.48 18.38 5.48 6.66 0 12.85-1.93 17.97-5.22h.03L100 142.1l-46.8-29.25 46.81-52.8V14.22c-4.55 0-9.08 1.81-12.3 5.44"
    />
    <path
      fill="#CBF8FF"
      fillRule="nonzero"
      d="m53.2 112.86.57.34L100 142.1h.01V60.08l-.01-.01z"
    />
    <path
      fill="#074793"
      fillRule="nonzero"
      d="M189.25 133c8.05-5.03 9.67-15.62 3.47-22.63l-52.77-59.52a33 33 0 0 0-14.08-3.12 32.7 32.7 0 0 0-24.68 11l-1.17 1.32 46.8 52.8-46.8 29.25v43.67c3.07 0 6.13-.84 8.82-2.51z"
    />
    <path
      fill="#0294E4"
      fillRule="nonzero"
      d="M100.01 14.22v45.84l1.17-1.32c5.9-6.72 14.76-11 24.68-11 5.06 0 9.82 1.15 14.08 3.12l-27.65-31.2A16.3 16.3 0 0 0 100 14.24z"
    />
    <path
      fill="#96BCC2"
      fillRule="nonzero"
      d="m146.8 112.86-46.79-52.79v82.03z"
    />
  </svg>,
  "EntraId",
);
export default EntraIdIcon;
